define('ScrollToTerm/ScrollToTerm',[],

    function () {

        function start() {
            $(document).ready(function () {
                if ($(".glossary-container")[0]) {

                    var navBarHeight = document.getElementById("navbar").offsetHeight;

                    window.addEventListener("hashchange", function () {
                        window.scrollTo(window.scrollX, window.scrollY - navBarHeight);
                    })

                }
            });
        }

        return {
            start: start
        }

    }

);
